import React from 'react'
import Layout from '../components/layout'
import Contacthero from '../components/wt/Contacthero'

const Contact = () => (
    <Layout>
        <Contacthero />
    </Layout>
)

export default Contact